export async function useIntercomHash(): Promise<string> {
  const user = useUser()
  if (user.isSignedIn && user.user.value?.id) {
    const data = await $fetch('/api/auth/intercom')
    return data as string
  }
  return ''
}
